import { Button, Drawer } from "antd";
import CampaignHelper from "helpers/CampaignHelper";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Timeline, TimelineEvent } from "react-event-timeline";
import arrow from "static/icons/arrow.svg";
import email from "static/icons/email.svg";
import AddToCart from "static/icons/user-journeys/add-to-cart.svg";
import EyeIcon from "static/icons/user-journeys/eye-icon.svg";
import facebokicon from "static/icons/user-journeys/facebook_01.svg";
import GoogleAdsIcon from "static/icons/user-journeys/google_ads_icon.png";
import instagramicon from "static/icons/user-journeys/instagram_01.svg";
import shopifyicon from "static/icons/user-journeys/shopify_01.svg";
import tiktokicon from "static/icons/user-journeys/tiktok.png";

const FacebookAdTimeline = ({ type, date = new Date(), utm_campaign }) => {
    return (
        <TimelineEvent title="Title" className="facebook-time-event" bubbleStyle={{ border: "none", background: 'linear-gradient(90deg, #2C5088 0%, #1B35D5 100%)', borderRadius: "6px", width: "36px", height: "36px" }} icon={<img src={facebokicon} alt="facebook" style={{ width: "20px" }} />} >
            <div className="purchase-time">
                <h3>{moment(date).format("MM-DD-YY | hh:mm:ss")}</h3>
            </div>
            <div className="purchase-detail">
                <h4>{type}</h4>
                <div className="product-box">
                    {utm_campaign && <p><span>Campaign</span> - {utm_campaign}</p>}
                    <p><span>Adset</span> - Interests Bed city</p>
                    <p><span>Ad</span> - Dynamic Ad</p>
                </div>
            </div>
        </TimelineEvent>
    )
}

const OmnisendTimeline = ({ date = new Date(), type }) => {
    return (
        <TimelineEvent title="Title" className="email-time-event" icon={<img className="email-icon" src={email} alt="email" />} bubbleStyle={{ background: 'linear-gradient(90deg, #B778FD 0%, #6800FF 100%)', borderRadius: "6px", width: "36px", height: "36px", border: "none" }}>
            <div className="purchase-time">
                <h3>{moment(date).format("MM-DD-YY | hh:mm:ss")}</h3>
            </div>
            <div className="purchase-detail">
                <h4>{type} <span>Vintage Collection(ULFAVB)</span></h4>
            </div>
        </TimelineEvent>
    )
}

export const TiktokAdTimeline = ({ type, date = new Date(), utm_campaign }: any) => {
    return (
        <TimelineEvent title="Title" className="tiktok-time-event" bubbleStyle={{ border: "none", background: 'linear-gradient(90deg, #581845 0%, #872657 100%)', borderRadius: "6px", width: "36px", height: "36px" }} icon={<img src={tiktokicon} alt="tiktok" style={{ width: "20px" }} />} >
            <div className="purchase-time">
                <h3>{moment(date).format("MM-DD-YY | hh:mm:ss")}</h3>
            </div>
            <div className="purchase-detail">
                <h4>{type}</h4>
                <div className="product-box">
                    {utm_campaign && <p><span>Campaign</span> - {utm_campaign}</p>}
                    <p><span>Adset</span> - Interests Bed city</p>
                    <p><span>Ad</span> - Dynamic Ad</p>
                </div>
            </div>
        </TimelineEvent>
    )
};


const DefaultTimeline = ({ date = new Date(), type }) => {
    return (
        <TimelineEvent title="Title" className="email-time-event" icon={<img className="email-icon" src={email} alt="email" />} bubbleStyle={{ background: 'linear-gradient(90deg, #B778FD 0%, #6800FF 100%)', borderRadius: "6px", width: "36px", height: "36px", border: "none" }}>
            <div className="purchase-time">
                <h3>{moment(date).format("MM-DD-YY | hh:mm:ss")}</h3>
            </div>
            <div className="purchase-detail">
                <h4>{type} <span>Vintage Collection(ULFAVB)</span></h4>
            </div>
        </TimelineEvent>
    )
}

const InstagramAdTimeline = ({ date = new Date(), type }) => {
    return (
        <TimelineEvent title="Title" className="instagram-time-event" bubbleStyle={{ border: "none", background: 'linear-gradient(90deg, #D8545B 0%, #A035B3 100%)', borderRadius: "6px", width: "36px", height: "36px" }} icon={<img className="inst-icon" src={instagramicon} alt="email" style={{ width: "20px" }} />}>
            <div className="purchase-time">
                <h3>{moment(date).format("MM-DD-YY | hh:mm:ss")}</h3>
            </div>
            <div className="purchase-detail">
                <h4>{type}</h4>
                <div className="product-box">
                    <p><span>Campaign</span> - TOF AU 1% LAL linen</p>
                    <p><span>Adset</span> - Interests Bed city</p>
                    <p><span>Ad</span> - Dynamic Ad</p>
                </div>
            </div>
        </TimelineEvent>
    )
}

const PreviewAddTocartTimeline = ({ type, date, location }) => {
    const dateFormat = (date) => moment(date).format("MM-DD-YY | hh:mm:ss")
    return (
        <div>
            <div className="timeline-preview-event">
                <div className="eye-icon"><img src={type === "Pageview" ? EyeIcon : AddToCart} alt="eye-iccon" className={type === "Pageview" ? "pageview-icon" : "add-to-cart-icon"} /></div>
                <div className="date-time">{dateFormat(date)}</div>
                <div className="evet-type">{type}</div>
                <div className="event-link">{location}</div>
            </div>
        </div>
    )
}

const EmailTimeline = ({ date = new Date(), type }) => {
    return (
        <TimelineEvent title="Title" className="email-time-event" icon={<img className="email-icon" src={email} alt="email" />} bubbleStyle={{ background: 'linear-gradient(90deg, #B778FD 0%, #6800FF 100%)', borderRadius: "6px", width: "36px", height: "36px", border: "none" }}>
            <div className="purchase-time">
                <h3>{moment(date).format("MM-DD-YY | hh:mm:ss")}</h3>
            </div>
            <div className="purchase-detail">
                <h4>{type} <span>Vintage Collection(ULFAVB)</span></h4>
            </div>
        </TimelineEvent>
    )
}

const GoogleTimeline = ({ date = new Date(), type }) => {
    return (
        <TimelineEvent title="Title" icon={<img src={GoogleAdsIcon} alt="email" style={{ width: "20px" }} />} className="google-time-event" bubbleStyle={{ background: 'linear-gradient(90deg, #FAFFFA 0%, #F4FAF6 11%, #DCE4E4 66%, #D3DCDD 100%)', borderRadius: "6px", width: "36px", height: "36px", border: "none" }}>
            <div className="purchase-time">
                <h3>{moment(date).format("MM-DD-YY | hh:mm:ss")}</h3>
            </div>
            <div className="purchase-detail">
                <h4>{type}</h4>
                <div className="product-box">
                    <p><span>Campaign</span> - TOF AU 1% LAL linen</p>
                    <p><span>Adset</span> - Interests Bed city</p>
                    <p><span>Ad</span> - Dynamic Ad</p>
                </div>
            </div>
        </TimelineEvent>
    )
}

const EventTimeLines = ({ event, date, location, utm_source = "", index, events, catIndex, utm_campaign }) => {
    let campaignName = CampaignHelper.lookupCampaignName(utm_campaign);
    const props = { date: date, location: location, utm_campaign: campaignName };
    const SubEventArray = {
        "pageview": <PreviewAddTocartTimeline {...props} type="Pageview" />,
        "add-to-cart": <PreviewAddTocartTimeline {...props} type="Add to cart" />,
    }
    const eventsArray = {
        "email": <EmailTimeline {...props} type="Email" />,
        "fb": <FacebookAdTimeline {...props} type="Facebook Ads" />,
        "facebook": <FacebookAdTimeline {...props} type="Facebook Ads" />,
        "ig": <InstagramAdTimeline {...props} type="Instagram" />,
        "instagram": <InstagramAdTimeline {...props} type="Instagram" />,
        "IGShopping": <InstagramAdTimeline {...props} type="Instagram" />,
        "google": <GoogleTimeline  {...props} type={"Google"} />,
        "google-ads": <GoogleTimeline  {...props} type={"Google"} />,
        "tiktok": <TiktokAdTimeline {...props} type="Tiktok Ads" />,
        "omnisend": <OmnisendTimeline {...props} type="Omnisend" />,
        "default": <DefaultTimeline {...props} type="Email" />
    }

    if (index === 0)
        if (!catIndex)
            return SubEventArray[events] || SubEventArray["pageview"];
        else
            return eventsArray[utm_source] || eventsArray['default'];
    else
        return SubEventArray[event] || SubEventArray["pageview"];
}

export const UJDrawer = ({ onCloseDrawer, events = [], visible, journeyPurchase }: any) => {

    const [catagoryEvents, setCatagoryEvents] = useState([]);
    const [firstEvent, setFirstEvent] = useState({ eventName: "default", background: "90deg, #18E7D2 0%, #049B5B 100%", icon: shopifyicon, className: "purchase-time-event" });

    useEffect(() => {
        if (events.length) {
            const newCatagorysEvents = events.reduce((newcatagorys, event, i) => {
                if (!event?.utm_source) {
                    if (!newcatagorys.length)
                        newcatagorys[0] = { ...newcatagorys[0], data: [...newcatagorys[0]?.data || [], event], hide: true }
                    else
                        newcatagorys[newcatagorys.length - 1] = { ...newcatagorys[newcatagorys.length - 1], data: [...newcatagorys[newcatagorys.length - 1]?.data || [], event] }
                    return newcatagorys;
                }
                if (event.utm_source && (event.utm_source === events[i - 1]?.utm_source)) {
                    newcatagorys[newcatagorys.length - 1] = { ...newcatagorys[newcatagorys.length - 1], data: [...newcatagorys[newcatagorys.length - 1]?.data || [], event] }
                } else
                    newcatagorys[newcatagorys.length] = { data: [event], hide: true }
                return newcatagorys;
            }, []);

            setCatagoryEvents(newCatagorysEvents)
        }
    }, [events]);

    // useEffect(() => {
    //   const events = [
    //     {eventName: "email", background: "90deg, #B778FD 0%, #6800FF 100%", icon: email, className: "email-time-event"},
    //     {eventName: "fb", background: "90deg, #2C5088 0%, #1B35D5 100%", icon: facebokicon, className: "facebook-time-event"},
    //     {eventName: "facebook", background: "90deg, #2C5088 0%, #1B35D5 100%", icon: facebokicon, className: "facebook-time-event"},
    //     {eventName: "ig", background: "90deg, #D8545B 0%, #A035B3 100%", icon: instagramicon, className: "instagram-time-event" },
    //     {eventName: "instagram", background: "90deg, #D8545B 0%, #A035B3 100%", icon: instagramicon, className: "instagram-time-event" },
    //     {eventName: "IGShopping", background: "90deg, #D8545B 0%, #A035B3 100%", icon: instagramicon, className: "instagram-time-event" },
    //     {eventName: "google-ads", background: "90deg, #FAFFFA 0%, #F4FAF6 11%, #DCE4E4 66%, #D3DCDD 100%", icon: GoogleAdsIcon, className: "google-time-event" },
    //     {eventName: "google", background: "90deg, #FAFFFA 0%, #F4FAF6 11%, #DCE4E4 66%, #D3DCDD 100%", icon: GoogleAdsIcon, className: "google-time-event" },
    //     {eventName: "tiktok", background: "90deg, #581845 0%, #872657 100%", icon: tiktokicon, className: "tiktok-time-event" },
    //     {eventName: "omnisend", background: "90deg, #B778FD 0%, #6800FF 100%", icon: email, className: "email-time-event" },
    //     {eventName: "default", background: "90deg, #18E7D2 0%, #049B5B 100%", icon: shopifyicon, className: "purchase-time-event" },
    //   ]
    //   const selectedEvent = events.find((event) => event.eventName === journeyPurchase?.utm_source);
    //   setFirstEvent(selectedEvent ? selectedEvent : events.find((event)=> event.eventName === "default"));
    // }, [journeyPurchase]);

    const onLoadMore = (index) => {
        catagoryEvents[index].hide = !catagoryEvents[index].hide
        setCatagoryEvents([...catagoryEvents]);
    }

    return (

        <Drawer placement="bottom" className="user-journey-drawer" closable={false} onClose={onCloseDrawer} visible={visible} key={"bottom"}>

            <div className="drawer-hearer">
                <div className="drawer-hearer-title-wraper">
                    <p className="drawer-hearer-title cust-title">Customer</p>
                    <strong className="drawer-hearer-title-email">{journeyPurchase?.email}</strong>
                </div>
                <div className="drawer-hearer-close" onClick={onCloseDrawer}>X</div>
            </div>

            <Timeline className="user-journey-timeline">

                <TimelineEvent title="Title" className={firstEvent?.className} bubbleStyle={{ border: "none", background: `linear-gradient(${firstEvent?.background})`, borderRadius: "6px", width: "36px", height: "36px" }} icon={<img src={firstEvent?.icon} alt="facebook" style={{ width: "22px" }} />}>
                    <div className="purchase-time">
                        <h3>{moment(journeyPurchase?.date).format("MM-DD-YY | hh:mm:ss")}</h3>
                        <p>Order ID:<span>{journeyPurchase?.orderId}</span></p>
                    </div>
                    <div className="purchase-detail">
                        <h4>Purchase <span>${journeyPurchase?.price}</span></h4>
                        <div className="product-box">
                            {journeyPurchase?.items.map(({ title, quantity, price }) => <p>{title} for ${quantity * price}</p>)}
                        </div>
                    </div>
                </TimelineEvent>

                <div>
                    {catagoryEvents.length ? catagoryEvents.map((events, catIndex) => events.data.length ?
                        (<div>
                            {events.data.map((event, i) => (i < (events.hide ? 4 : events.data.length)) ? <EventTimeLines events={events.data} key={i} catIndex={catIndex} index={i} {...event} /> : <div />)}
                            {events.data.length > 4 ? (<div><span className="page-view"><Button onClick={() => onLoadMore(catIndex)}>PAGEVIEWS <img className={!events.hide && "downarrow"} src={arrow} alt="arrow" /></Button></span></div>) : <div />}
                        </div>)
                        : <div />)
                        : <div />}
                    {/* {events?.length ? events?.map((event, i) => <EventTimeLines events={events} key={i} index={i} {...event} />) : <div />} */}
                </div>

                <TimelineEvent title="Title" />

            </Timeline>

        </Drawer>

    )
}